<template>
  <div class="layout-side select-none"
       v-loading="menu.loading"
       element-loading-text="菜单加载中，请稍等..."
       :class="{'collapsed': navMenuObj.isCollapsed, 'empty-menu': !menu.dataList || menu.dataList.length === 0}">
    <div class="side-header">
      <div v-if="!navMenuObj.isCollapsed"
           class="tree-menu-group">
        <el-button class="locate-menu" type="text" @click="locateToActiveItem">
          <i class="iconfont icon-source"></i>
        </el-button>
        <el-button class="stretch-menu" type="text" @click="toggleExpandAllMenu">
          <i class="iconfont" :class="menu.expanded ? 'icon-menu-fold' : 'icon-menu-unfold'"></i>
        </el-button>
      </div>
      <el-input class="tree-search-input"
                placeholder="搜索菜单..."
                v-model.trim="search.keyword"
                :clearable="true"
                @focus="expandSideNavMenu">
        <i slot="prefix" class="iconfont icon-magnifier"></i>
      </el-input>
    </div>
    <div class="side-body layout-animate" v-if="!menu.loading">
      <div class="side-menu" v-if="menu.dataList">
        <Hint class="menu-is-empty"
              v-if="menu.dataList.length === 0"
              type="empty">
          <span>菜单列表数据为空</span>
        </Hint>
        <Hint class="menu-is-empty"
              v-else-if="emptyFilterMenu"
              :icon="false">
          <span>没有匹配到相关菜单</span>
        </Hint>
        <AppScrollbar ref="sideScroll"
                      style="height: 100%">
          <el-menu ref="sideNavMenu" :default-active="menu.current" :collapse="navMenuObj.isCollapsed" :collapse-transition="false" @select="handleMenuItemSelect" :style="navMenuStyle">
            <el-menu-item index="hiddenMenuItem" v-show="false">
              <!-- 隐藏菜单 -->
            </el-menu-item>
            <ElementMenu ref="sideNavMenuItem"
                         v-for="(menuItem, index) in menuItemList"
                         :key="'menu-item-' + index"
                         :menu-item="menuItem"
                         :menu-data-list="menu.dataList"
                         :filter-key="search.keyword"></ElementMenu>
          </el-menu>
        </AppScrollbar>
      </div>
      <template v-else>
        <Hint class="menu-load-failed"
              v-if="menu.isLoaded"
              :icon="false">
          <span>菜单数据加载失败</span>
          <div class="button-group">
            <el-button type="info" size="mini" @click="loadMenuData">点击重试</el-button>
          </div>
        </Hint>
      </template>
      <div class="side-menu-top-shadow" v-if="menu.dataList && menu.dataList.length"></div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from './elements/AppScrollbar'
import ElementMenu from './elements/ElementMenu'
import Hint from './elements/Hint'
import scrollUtils from '../util/scrollUtils'
import routeUtils from '../util/routeUtils'
import layoutConstants from '../constants/layoutConstants'
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'LayoutSide',
  components: {AppScrollbar, ElementMenu, Hint},
  data () {
    return {
      search: {
        keyword: ''
      },
      menu: {
        loading: false,
        isLoaded: false,
        expanded: false,
        dataList: null,
        current: ''
      }
    }
  },
  computed: mapState({
    navMenuObj: state => state.layout.side.navMenu,
    menuItemList: function () {
      let menuDataList = this.menu.dataList
      if (menuDataList) {
        return menuDataList.filter(data => !data.parentId)
      }
    },
    navMenuStyle: function () {
      if (this.navMenuObj.isCollapsed) {
        return {}
      } else {
        return {
          'marginLeft': '-10px'
        }
      }
    },
    emptyFilterMenu: function () {
      if (this.search.keyword) {
        let sideNavMenuItem = this.$refs['sideNavMenuItem']
        if (sideNavMenuItem) {
          return sideNavMenuItem.every(menuItem => {
            return !menuItem.isShowMenu
          })
        }
      }
      return false
    }
  }),
  methods: {
    ...mapMutations(['expandSideNavMenu']),
    ...mapMutations(['hideSideNavMenu']),
    ...mapMutations(['addMainTab']),
    locateToActiveItem () {
      let sideNavMenu = this.$refs['sideNavMenu']
      if (sideNavMenu) {
        let activeIndex = sideNavMenu.activeIndex
        if (activeIndex) {
          let selectItem = (sideNavMenu.items || {})[activeIndex]
          if (selectItem) {
            let activeItem = selectItem
            while (!activeItem.$el.clientHeight) {
              activeItem = activeItem.$parent
              if (!activeItem || activeItem === sideNavMenu) {
                return
              }
            }
            this.scrollToMenuItem(activeItem)
            if (activeItem !== selectItem) {
              sideNavMenu.initOpenedMenu()
              setTimeout(() => {
                this.scrollToMenuItem(selectItem)
              }, 300)
            }
          }
        }
      }
    },
    scrollToMenuItem (menuItem) {
      let {top: offsetTop, height: offsetHeight} = menuItem.$el.getBoundingClientRect()
      let sideScroll = this.$refs['sideScroll']
      if (sideScroll) {
        let sideScrollbar = sideScroll.$refs['appScrollbar']
        if (sideScrollbar) {
          let sideWrapView = sideScrollbar.$refs['wrap']
          let {top: sOffsetTop, height: sOffsetHeight} = sideScroll.$el.getBoundingClientRect()
          if (offsetTop < sOffsetTop || offsetTop - sOffsetTop > sOffsetHeight - offsetHeight) {
            // 滚动到视图25%的位置
            scrollUtils.scrollBy(offsetTop - sOffsetTop - (sOffsetHeight - offsetHeight) / 4, sideWrapView)
          }
        }
      }
    },
    toggleExpandAllMenu () {
      this.menu.expanded ? this.collapseAllMenu() : this.expandAllMenu()
    },
    expandMenuItem (navMenu, menu) {
      let submenus = menu.submenus
      if (submenus) {
        Object.keys(submenus).forEach(key => {
          this.expandMenuItem(navMenu, submenus[key])
        })
      }
      let indexPath = menu.indexPath
      if (indexPath.length === 1) {
        this.$nextTick(() => {
          navMenu.openMenu(menu.index, menu.indexPath)
        })
      } else {
        navMenu.openMenu(menu.index, menu.indexPath)
      }
    },
    expandTopMenu () {
      let sideNavMenu = this.$refs['sideNavMenu']
      if (sideNavMenu) {
        let menuItemList = this.menuItemList
        if (menuItemList && menuItemList.length <= layoutConstants.views.side.menu.threshold) {
          let submenus = sideNavMenu.submenus
          if (submenus) {
            let isExpandAll = true
            Object.keys(submenus).forEach(key => {
              let submenu = submenus[key]
              if (submenu.indexPath.length === 1) {
                sideNavMenu.openMenu(submenu.index, submenu.indexPath)
              } else {
                isExpandAll = false
              }
            })
            this.menu.expanded = isExpandAll
          }
        }
      }
    },
    expandAllMenu () {
      let sideNavMenu = this.$refs['sideNavMenu']
      if (sideNavMenu) {
        let submenus = sideNavMenu.submenus
        if (submenus) {
          Object.keys(submenus).forEach(key => {
            let submenu = submenus[key]
            if (submenu.indexPath.length === 1) {
              this.expandMenuItem(sideNavMenu, submenu)
            }
          })
        }
        this.menu.expanded = true
      }
    },
    collapseAllMenu () {
      let sideNavMenu = this.$refs['sideNavMenu']
      if (sideNavMenu) {
        let openedMenus = sideNavMenu.openedMenus.concat()
        if (openedMenus) {
          openedMenus.forEach(menu => sideNavMenu.close(menu))
        }
        this.menu.expanded = false
      }
    },
    handleMenuItemSelect (key, keyPath) {
      // 隐藏菜单
      if (this.navMenuObj.isShow) {
        this.hideSideNavMenu()
      }
      // 获取菜单
      let menuDataList = this.menu.dataList
      let selectMenu
      if (menuDataList) {
        selectMenu = menuDataList.find(data => data.name === key)
      }
      if (selectMenu) {
        this.addMainTab({
          name: selectMenu.name,
          label: selectMenu.label,
          icon: selectMenu.icon,
          path: selectMenu.path
        })
      } else {
        this.$notify.error({
          title: '提示信息',
          message: '菜单数据不存在',
          showClose: false
        })
      }
    },
    loadMenuData () {
      this.menu.loading = true
      this.$ajax({
        url: '/workspace/manager/center/menu',
        method: 'post'
      }).then((response) => {
        if (response.data) {
          this.menu.dataList = response.data['menuList']
          this.fireRouteChange()
        }
      }).finally(() => {
        this.menu.loading = false
        this.menu.isLoaded = true
      })
    },
    // 路由发生改变
    fireRouteChange () {
      // 根据路由调整选中菜单
      let matchId = routeUtils.getRouteMatchId(this, this.$route)[0]
      if (this.menu.dataList) {
        let matched = this.menu.dataList.some(item => {
          if (item.path && item.name === matchId) {
            return true
          }
        })
        if (matched) {
          this.menu.current = matchId
          return
        }
      }
      this.menu.current = 'hiddenMenuItem'
    }
  },
  mounted () {
    this.loadMenuData()
  },
  watch: {
    'menu.isLoaded': function (val) {
      if (val && layoutConstants.views.side.menu.expandTop) {
        this.$nextTick(() => {
          // 默认展开一级菜单
          this.expandTopMenu()
        })
      }
    },
    'search.keyword': function () {
      if (this.search.keyword) {
        this.$nextTick(() => {
          // 搜索发生变化展开全部菜单
          this.expandAllMenu()
        })
      }
    },
    'navMenuObj.isCollapsed': {
      handler (val) {
        // 清除搜索值
        this.search.keyword = ''
        this.menu.expanded = false
      },
      immediate: true
    },
    'navMenuObj.isShow': {
      handler (val) {
        if (val && this.navMenuObj.isCollapsed) {
          // 展示完整菜单
          this.expandSideNavMenu()
        }
      },
      immediate: true
    },
    '$route': function () {
      this.fireRouteChange()
    }
  }
}
</script>

<style lang="scss">
  .layout-side {
    position: relative;
    height: 100%;
    &.collapsed {
      & > .side-header {
        & > .tree-search-input {
          overflow: hidden;
          &:hover {
            & > .el-input__prefix {
              i {
                background-color: rgba(255,255,255,.3);
              }
            }
          }
          & > .el-input__inner {
            position: relative;
            background-color: transparent!important;
            z-index: 1;
          }
          & > .el-input__prefix {
            right: 5px;
            i {
              width: 36px;
              background-color: rgba(255,255,255,.1);
              border-radius: 50%;
              transition: all .3s;
            }
          }
        }
      }
      & > .side-body {
        & > .side-menu {
          & > .el-scrollbar {
            .el-menu {
              padding-top: 0;
              &.el-menu--collapse {
                width: 72px;
              }
              .el-menu-item,
              .el-submenu__title {
                padding-left: 0!important;
                padding-right: 0!important;
                height: 54px;
                line-height: 54px;
                text-align: center;
                .el-tooltip {
                  padding-left: 0!important;
                  padding-right: 0!important;
                }
                i {
                  position: absolute;
                  left: 50%;
                  width: 24px!important;
                  margin-left: -12px!important;
                  margin-right: 0!important;
                }
              }
            }
          }
        }
        .menu-load-failed,
        .menu-is-empty {
          display: none;
        }
      }
    }
    &.empty-menu {
      & > .side-header {
        display: none;
      }
      & > .side-body {
        top: 0;
        .layout-hint {
          background-color: rgba(255,255,255,.1);
        }
      }
    }
    & > .side-header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 40px;
      & > .tree-menu-group {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        color: #909399;
        padding: 0 6px;
        text-align: center;
        border-radius: 0;
        transition: all .3s;
        z-index: 1;
        display: flex;
        align-items: center;
        .el-button {
          i {
            font-size: 15px!important;
          }
          &.stretch-menu {
            i {
              font-size: 18px!important;
            }
          }
          & + .el-button {
            margin-left: 0;
          }
        }
      }
      & > .tree-search-input {
        height: 100%;
        border: 1px solid transparent;
        box-sizing: border-box;
        & > .el-input__inner {
          font-size: 12px;
          height: 38px;
          line-height: 38px;
          color: rgba(255,255,255,.8);
          background-color: rgba(255,255,255,.1);
          border: none;
          border-radius: 0;
          padding-right: 60px;
          transition: all .3s;
        }
        & > .el-input__prefix {
          line-height: 36px;
          transform: scale(.8);
        }
        & > .el-input__suffix {
          right: 60px;
          line-height: 38px;
          .el-input__icon {
            vertical-align: -1px;
          }
        }
      }
    }
    & > .side-body {
      position: absolute;
      left: 0;
      top: 40px;
      right: 0;
      bottom: 0;
      & > .side-menu {
        position: relative;
        height: 100%;
        & > .el-scrollbar {
          .el-menu {
            padding-top: 10px;
            padding-bottom: 20px;
            background-color: transparent;
            border-right: none;
            &.el-menu--collapse {
              padding-bottom: 10px;
            }
            &:before {
              content: '';
              display: table;
            }
            &:after {
              content: '';
              display: table;
              clear: both;
            }
            .el-menu-item,
            .el-submenu__title {
              margin-bottom: 5px;
              padding-right: 5px;
              height: 40px;
              font-size: 14px;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              transition: all .3s;
              i {
                font-size: 17px!important;
                margin-right: 2px!important;
                transition: all .3s;
                &.el-submenu__icon-arrow {
                  font-size: 12px!important;
                  right: 10px;
                }
              }
              &:focus,
              &:hover {
                background-color: transparent;
              }
            }
            .el-submenu {
              .el-menu {
                padding-top: 0;
                padding-bottom: 0;
                .el-menu-item,
                .el-submenu__title {
                  height: 40px!important;
                  font-size: 13px;
                  line-height: 40px!important;
                  i {
                    transform: scale(.9) translateX(10%);
                    &.el-submenu__icon-arrow {
                      display: none;
                    }
                  }
                }
                .el-submenu {
                  & > .el-submenu__title {
                    & > .submenu-title-wrap {
                      position: relative;
                      padding-left: 1px;
                      &:before {
                        content: '';
                        position: absolute;
                        left: -6px;
                        top: 50%;
                        width: 0;
                        height: 0;
                        margin-top: -5px;
                        border-left: 5px solid #fff;
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid transparent;
                        border-right: none;
                        transition: all .3s;
                      }
                    }
                  }
                  &.is-opened {
                    & > .el-submenu__title {
                      & > .submenu-title-wrap {
                        &:before {
                          transform: rotate(45deg);
                          transform-origin: 25% center;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .el-menu {
          background-color: transparent;
          border-right: none;
        }
      }
      & > .side-menu-top-shadow {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(to bottom, rgba(0,21,41,.35), transparent);
      }
      .menu-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 3px 6px;
            border-radius: 0;
          }
        }
      }
      .menu-is-empty {
        font-size: 12px;
        text-align: center;
      }
    }
  }
</style>
